import _m2mClient from './m2mClient';

export const m2mClient = _m2mClient;

export default { m2mClient };
